import React from 'react'
import StaffSelectListViewItem from './StaffSelectListViewItem'

export default ({ staffs, createStaffClickHandler, selectedStaff }) => {
  if (staffs === undefined) return renderEmptyState()

  if (staffs.length === 0) return renderNoStaffFound()

  return (
    <div className="bg-white border border-gray-200 rounded-lg h-[32vh] overflow-auto text-base text-center">
      {renderStaffList(staffs, createStaffClickHandler, selectedStaff)}
    </div>
  )
}

const renderEmptyState = () => (
  <div className="bg-white border border-gray-200 rounded-lg h-[32vh] flex items-center justify-center text-base">
    <p className="text-gray-500">Search for staff to assign</p>
  </div>
)

const renderNoStaffFound = () => (
  <div className="bg-white border border-gray-200 rounded-lg h-[32vh] flex items-center justify-center text-base">
    NO STAFF FOUND
  </div>
)

const renderStaffList = (staffs, createStaffClickHandler, selectedStaff) => {
  return staffs.map((staff) => (
    <StaffSelectListViewItem
      key={staff._id}
      staff={staff}
      onClick={createStaffClickHandler(staff)}
      isSelected={selectedStaff && selectedStaff._id === staff._id}
    />
  ))
}
